import React, { Fragment } from 'react';
import DocumentTitle from 'react-document-title';

import LeadershipPage from '../components/company/leadership-page';

const LeadershipRoute = () => (
  <Fragment>
    <DocumentTitle title="Company | NerdWallet" />
    <LeadershipPage />
  </Fragment>
);

LeadershipRoute.displayName = 'LeadershipRoute';
LeadershipRoute.analyticsName = 'leadership_page';
LeadershipRoute.segmentPageName = 'leadership';

export default LeadershipRoute;
